var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephoneWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1408"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2111",
    className: "st0",
    d: "M5,0.1c0.8-0.2,1.7,0.2,2,1l1.7,4.1c0.3,0.7,0.1,1.5-0.5,2L6.2,8.9c1.4,3,3.9,5.5,6.9,6.9 l1.7-2.1c0.5-0.6,1.3-0.8,2-0.5l4.1,1.7c0.8,0.3,1.2,1.2,1,2l-1,3.8C20.7,21.5,20,22,19.3,22C8.6,22,0,13.4,0,2.8c0,0,0,0,0,0 C0,2,0.5,1.3,1.3,1.1L5,0.1z M12.4,8.3c0.8,0,1.4,0.6,1.4,1.4c0,0.8-0.6,1.4-1.4,1.4c-0.8,0-1.4-0.6-1.4-1.4 c0-0.2,0.1-0.5,0.2-0.7C11.4,8.5,11.9,8.3,12.4,8.3 M12,0c5.5,0,10,4.5,10,10c0,0.6-0.5,1-1,1s-1-0.5-1-1c0-4.4-3.5-7.9-7.9-7.9 c-0.6,0-1-0.5-1-1S11.5,0,12,0 M11,5.2c0-0.6,0.5-1,1-1c3.2,0,5.8,2.6,5.8,5.8c0,0.6-0.5,1-1,1c-0.6,0-1-0.5-1-1 c0-2.1-1.7-3.8-3.8-3.8C11.5,6.2,11,5.7,11,5.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneWhite);
export default __webpack_public_path__ + "static/media/Telephone_White.55c23b09692fd704f711dab0018e0c6d.svg";
export { ForwardRef as ReactComponent };